<mc-scope>
    <app-header id="header" #header></app-header>
    <app-score-panel></app-score-panel>
    <div class="main-area">
        <div class="legend-area" [ngClass]="{'closed': legendClosed }">
            <div class="loader is-active padding-leader-3 padding-trailer-3">
                <div class="loader-bars"></div>
            </div>
            <mc-legend id="mc-legend" class="legend block-display" #legend slot="legend" show-layer-detail="false"
                [ngClass]="{'show': !loadingArea }" (optionSelectedEvent)="onOptionSelect($event)"
                (attached)="optionsAttached($event)" (onsymbolchange)="onSymbolEditorClick($event)" readonly="false">
                <div slot="legend-layer-options" class="legend-layer-options dropdown js-dropdown">
                    <button class="btn btn-transparent icon-ui-filter filter-option" role="menuitem"
                        title="Filter"></button>
                    <button class="btn btn-transparent dropdown-btn icon-ui-settings layer-options-button" tabindex="0"
                        aria-haspopup="true" aria-expanded="false"></button>
                    <nav class="legend dropdown-menu dropdown-right" role="menu">
                        <button class="dropdown-link details" role="menuitem">
                            <span class="esri-icon-documentation"></span>Details
                        </button>
                        <button class="dropdown-link filter-option" role="menuitem">
                            <span class="esri-icon-filter"></span>Filter
                        </button>
                        <button class="dropdown-link data-table-option" role="menuitem"><span
                                class="esri-icon-table"></span>Data Table</button>
                        <button class="dropdown-link delete-option" role="menuitem"><span
                                class="esri-icon-close"></span>Delete</button>
                        <button class="dropdown-link export-excel-option" role="menuitem"><span
                                class="esri-icon-download"></span>Export Excel</button>
                        <button class="dropdown-link copy-option" role="menuitem"><span
                                class="esri-icon-minimize"></span>Copy</button>
                        <button class="dropdown-link zoom-option" role="menuitem"><span
                                class="esri-icon-zoom-in-fixed"></span>Zoom to Layer</button>
                    </nav>
                </div>
            </mc-legend>
        </div>
        <button class="legend-expander icon-ui-up-down-arrows btn btn-white" [ngClass]="{'closed': legendClosed }"
            (click)="toggleLegend()">
        </button>

        <div class="map-container" [ngClass]="{'full': legendClosed }">
            <mc-map id="mc-map" #map center="[-77.6362661695295, 40.92039887644528]" zoom="8"
                (largerImageRequest)="largerImageRequest($event)">
                <div slot="top-left">
                    <mc-extent #extent></mc-extent>
                </div>
                <mc-expander slot="top-left" expand-icon-class="esri-icon-basemap" auto-collapse="true"
                    expand-tooltip="Basemap">
                    <mc-basemap-switcher #basemapSwitcher></mc-basemap-switcher>
                </mc-expander>
                <mc-identify #identify slot="top-right" (featureUpdated)="featureUpdated($event)"
                    (docSourcesUpdated)="docSourcesUpdated($event)">
                </mc-identify>
                <mc-layer-tooltip id="tooltip" #tooltip slot="content" tooltip-enabled="true"></mc-layer-tooltip>
            </mc-map>

            <div (click)="dismissMapLoader()" class="map loader is-active padding-leader-3 padding-trailer-3"
                [ngClass]="{'show': showMapLoader }" [title]="mapLoaderTitle">
                <div class="loader-bars"></div>
            </div>

            <app-identify-buttons></app-identify-buttons>

        </div>
    </div>

    <mc-export-layer id="exportLayer" #exportLayer style="display:none"></mc-export-layer>

    <mc-window #disclaimerWindow id="disclaimerWindow" title="Disclaimer" width="875" modal="true">
        <div slot="content">
            <div class="disclaimer">
                The HBMS mapping tool is a web based interactive map solution using PennDOT’s Geographic Information
                System that is made available to assist applicants in applying for outdoor advertising device permits.
                This application shows state routes made part of the Interstate System and Primary System as defined
                under the Outdoor Advertising Control Act of 1971 (Act), and highways designated as Scenic Byways. This
                application also shows existing billboards as clickable points that display information from the
                billboard’s permit file. While PennDOT makes every effort to provide accurate information in this
                application, PennDOT makes no representations with regard to the accuracy or currency of the data and
                such data is subject to independent verification by PennDOT permitting staff. The user should not rely
                solely upon this data when applying for a permit to erect an outdoor advertising device under the Act.
                If you have any questions regarding the information provided in the HBMS mapping tool, please contact
                the district Highway Beautification Manager.
                <div class="buttons">
                    <button class="btn accept" (click)="acceptDisclaimer()">Accept</button>
                    <button class="btn btn-clear cancel" (click)="doNotAcceptDisclaimer()">I Do Not Accept</button>
                </div>
            </div>
        </div>
    </mc-window>

    <mc-window #filterLayerOptionsWindow id="filterLayerOptions" title="Filter Layer Options" modal="true" width="600">
        <div slot="content">
            <h4>Select a filter option for each layer.</h4>
            <div *ngFor="let layer of selectedLayers" class="selected-layer">
                <span>{{layer.name}}</span>
                <div class="fieldset-radio filter-type-picker">
                    <label>
                        <input type="radio" [name]="layer" value="showAll" [(ngModel)]="layer.filterType">Show
                        All
                    </label>
                    <label><input type="radio" [name]="layer" value="filter"
                            [(ngModel)]="layer.filterType">Filter</label>
                    <label *ngIf="layer.aoiQuery?.field || layer.aoiQuery?.subqueries"><input type="radio"
                            [name]="layer" value="aoi" [(ngModel)]="layer.filterType">AOI</label>
                </div>
            </div>
            <button class="btn btn-small btn-red" style="float:right;" (click)="closeFilterLayerOptionsWindow()">
                Cancel
            </button>
            <button class="btn btn-small" style="float:right; margin-right: 10px;" (click)="setFilters()">Next</button>
        </div>
    </mc-window>

    <mc-window #layerFilterContainerWindow id="layerFilterContainerWindow" title="Layer Filter" top="50" height="690"
        width="960">
        <mc-tabs id="mc-tabs" slot="content" tabs='[{"name":"Basic Query", "active":true}]'>
            <div slot="tab_1">
                <mc-layer-filter-container #layerFilterContainer id="layerFilter"></mc-layer-filter-container>
            </div>
        </mc-tabs>
    </mc-window>

    <mc-window #symbolEditorWindow id="symbolEditorWindow" title="Symbol Editor" is-draggable="true" is-resizable="true"
        width="530" top="75" left="300">
        <mc-symbol-editor-container #symbolEditor id="symbolEditor" slot="content">
            <mc-point-symbol-editor slot="point-symbol-editor"></mc-point-symbol-editor>
            <mc-line-symbol-editor slot="line-symbol-editor"></mc-line-symbol-editor>
            <mc-polygon-symbol-editor slot="polygon-symbol-editor"></mc-polygon-symbol-editor>
            <mc-text-symbol-editor slot="text-symbol-editor"></mc-text-symbol-editor>
            <mc-layer-opacity-editor slot="layer-opacity-editor"></mc-layer-opacity-editor>
        </mc-symbol-editor-container>
    </mc-window>

    <mc-window id="galleryWindow" #galleryWindow modal="true" title="Billboard Image Gallery" is-draggable="true"
        is-resizable="true">
        <mc-gallery id="gallery" #gallery slot="content"></mc-gallery>
    </mc-window>

    <mc-application-messages #applicatoinMessages class="application-messages" duration-in-ms="50000000"
        notification-levels="[0,1,2,3]">
    </mc-application-messages>

    <div class="data-table-container" [ngClass]="{ 'closed': dataTableMinimized, 'hidden': !dataTable.opened }">
        <mc-data-table id="dataTable" #dataTable slot="bottom-left" autogenerate-column-settings="true"
            max-default-columns="8" mc-data-table="">
        </mc-data-table>
        <button class="data-expander icon-ui-up-down-arrows btn btn-white" *ngIf="dataTableOpened"
            (click)="dataTableMinimized = !dataTableMinimized;"></button>
    </div>

</mc-scope>